"use client";

import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

export function SkipToContent() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <Button
      variant="default"
      className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:top-4 focus:left-4"
      onClick={() => {
        document.getElementById("main-content")?.focus();
      }}
    >
      Pular para o conteúdo
    </Button>
  );
}
